import React, {FC, memo, useContext, useEffect, useReducer, useState} from 'react';
import {UserContext} from '../../../../../contexts/user-context';
import {faChartLine, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import HeaderMenuItem from '../item';
import HeaderMenuSubItem from '../sub-item';
import {menuItemsList} from '../../../../../helpers/constants';
import useLogOut from '../../hook';
import {IHeaderMenu, IMenuItem, MenuItem} from '../../types';
// import {returnDashUrl} from '../../../../../helpers';

const Menu: FC<IHeaderMenu> = ({pathName, gravatarSrc, refectUserData}) => {
  //!---------------Context-----------------
  const {user} = useContext(UserContext);
  //!----------------State------------------
  //Boolean
  const [showSubItems, setShowSubItems] = useReducer((val: boolean) => !val, false);
  const [items, setItems] = useState<IMenuItem[]>(menuItemsList);
  //!----------hook------------
  const [log_out] = useLogOut();

  useEffect(() => {
    const list = pathName.includes('pricing') ? [] : [...menuItemsList];
    if (!user || !user.id) {
      list.push(
        {
          name: 'Login',
          linkTo: `/#login`,
          className: 'nav-link header_login_btn d-md-none',
        },
        {
          name: 'Get started',
          linkTo: '/#registration',
          className: 'nav-link software_banner_btn header_registration_btn d-md-none',
          icon: undefined,
        },
        // {
        //   name: 'Request a demo',
        //   linkTo: '/#demo',
        //   className: 'nav-link software_banner_btn header_registration_btn outline d-lg-none',
        //   icon: undefined,
        // },
      );
    } else {
      list.push({
        name: user.firstName || '',
        className: 'nav-link loggedin-items d-lg-none',
        img: true,
        src: '',
        func: setShowSubItems,
        showSubItems: showSubItems,
        subItems: [
          // {
          //   name: 'Dashboard',
          //   className: 'nav-link loggedin-items d-lg-none',
          //   linkTo: returnDashUrl(),
          //   icon: faChartLine,
          // },
          {
            name: 'Sign out',
            className: 'nav-link loggedin-items d-lg-none',
            icon: faSignOutAlt,
            func: async () => {await log_out(); refectUserData()},
          },
        ],
      });
    }
    setItems(list);
  }, [user, showSubItems]);
  return (
    <>
      {items.map((item: MenuItem) => (
        <li
          key={item.name}
          className={classNames('nav-item dropdown submenu', {
            active: item.linkTo === pathName || item.showSubItems,
            dropdownMenu: item.subMenu,
          })}
        >
          <HeaderMenuItem
            to={item.linkTo}
            name={item.name}
            target={item.target}
            icon={item.icon}
            img={item.img}
            src={gravatarSrc}
            className={item.className}
            func={item.func}
            showSubItems={item.showSubItems}
          />
          {item.subItems && (
            <ul
              className={classNames('dropdown-menu avatar', {
                show: item.showSubItems,
              })}
            >
              {item.subItems.map(
                (subItem: MenuItem): JSX.Element => (
                  <HeaderMenuSubItem
                    key={subItem.name}
                    to={subItem.linkTo}
                    name={subItem.name}
                    target={subItem.target}
                    icon={subItem.icon}
                    className={subItem.className}
                    func={subItem.func}
                  />
                ),
              )}
            </ul>
          )}
          {item.subMenu && (
            <ul
              className={classNames('subMenu', {
                show: item.showSubItems,
              })}
            >
              {item.subMenu.map(
                (subItem: MenuItem): JSX.Element => (
                  <HeaderMenuSubItem
                    key={subItem.name}
                    to={subItem.linkTo}
                    name={subItem.name}
                    target={subItem.target}
                    icon={subItem.icon}
                    className={subItem.className}
                    func={subItem.func}
                  />
                ),
              )}
            </ul>
          )}
        </li>
      ))}
    </>
  );
};

export default memo(Menu);
